import React, { useEffect } from 'react';
import './About.css';
import ilona from './ilona.jpg';
import lacie from './lacie.jpg';
import sshrc from './sshrc.png';

function About() {

  useEffect(() => {
    document.querySelector('body').style.backgroundColor = '#eed9ae'
  }, []);

  return (
    <div className="AboutPage" >
      <h1 className="Title" >About</h1>
          <p className='TextBlock'>
          This chatbot introduces a new approach to language acquisition.
          Blackfoot is on the verge of disappearance as the number of native
          speakers dwindles. Averting extinction is the motivation for
          creating this chatbot. The Peigan Board of Education in partnership
          with the departments of Computing Science and Indigenous Studies
          developed this teaching aid to augment their Blackfoot language
          program. Exploring the potential of machine learning, robotics and
          artificial intelligence opens new platforms to pass the language on
          to future generations. While writing Blackfoot with standard Roman
          orthography began about fifty years ago, literacy is still a
          linguistic novelty. Generally, Indigenous people esteem the oral
          tradition and that has been the missing element in recruiting new
          speakers. We designed our contribution around the spoken word with
          the written version aiding the aural experience. Users of our
          chatbot will become familiar with reading and writing in Blackfoot
          as they become familiar with pronunciation, or accent and cadence.
          </p>
          <p className='TextBlock'>
            A, H, I, K, M, N, O, P, S, T, W, Y, ‘
          </p>
          <p className='TextBlock'>
            We employ the standard Blackfoot alphabet presented above, and the
            spelling conforms to the Blackfoot Dictionary of Stems, Roots and
            Affixes by Donald G. Frantz and Norma Jean Russell (1989, 2017).
            All the letters appear on a regular computer keyboard including
            the glottal stop, which is represented here by the apostrophe.
          </p>
        <div className='Acknowledgement'>
        <p className='SSHRC'>
          The Blackfoot Revitalization Project is supported in part by
          funding from the Social Sciences and Humanities Research Council
        </p>
        {
          <img className='SSHRCImage' src={sshrc}/>
         }
        </div>
    </div>
  );
}

export default About;
